// Text handed to Study Helper from another page (Notes' "Ask Study Helper"). The text is the
// page's, not the student's typing, so it is capped, labelled with where it came from, and the
// Helper asks before attaching it. Shared by app/helper-dock.js and tools/helper/index.js.

export const HANDOFF_CHARS = 6000;
export const HANDOFF_TITLE = 80;
export const HANDOFF_PROMPT = 500;
// The Helper's modes (helper-prompts.js MODES; kept here so the app bundle does not pull in the prompts).
export const HANDOFF_MODES = ["explain", "quiz", "check", "summarize", "cards"];

// Only these in-app pages may ask, and only from a Tools tab that shows them.
const SENDERS = new Set(["/tools/notes"]);

// True when `source` is the window of a Tools tab's frame (an in-app tab, never a site or a
// book) and that frame shows a sender page right now. frames: Map tabId -> iframe;
// tabs: [{ id, internal }].
export function handoffSenderOk(source, frames, tabs) {
	if (!source || !frames || !tabs) return false;
	let id = null;
	for (const [k, fr] of frames) if (fr && fr.contentWindow === source) { id = k; break; }
	if (id == null) return false;
	const t = tabs.find((x) => x.id === id);
	if (!t || typeof t.internal !== "string" || !/^\/tools(?:[/?#]|$)/.test(t.internal)) return false;
	try { return SENDERS.has(String(source.location.pathname).replace(/\/+$/, "")); } catch { return false; }
}

// The message the Helper gets: plain strings, capped, always marked as needing a yes first.
export function cleanHandoff(d) {
	const s = (v, n) => (typeof v === "string" ? v : "").split("\u0000").join("").slice(0, n);
	const mode = HANDOFF_MODES.includes(d && d.mode) ? d.mode : "";
	const text = s(d && d.text, HANDOFF_CHARS + 1);
	return {
		type: "revault-helper-handoff",
		mode,
		title: s(d && d.title, HANDOFF_TITLE).trim(),
		text: text.slice(0, HANDOFF_CHARS),
		cut: text.length > HANDOFF_CHARS,
		confirm: true,
	};
}
